/* tslint:disable */
import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from "@angular/common/http";
import { BaseService as __BaseService } from "../base-service";
import { ApiConfiguration as __Configuration } from "../api-configuration";
import { StrictHttpResponse as __StrictHttpResponse } from "../strict-http-response";
import { Observable as __Observable } from "rxjs";
import { map as __map, filter as __filter } from "rxjs/operators";

import { PaginatedCacheResultOfCompany } from "../models/paginated-cache-result-of-company";
import { PaginatedCacheResultOfIndustry } from "../models/paginated-cache-result-of-industry";
import { PaginatedCacheResultOfIndustry_Sector } from "../models/paginated-cache-result-of-industry-_sector";
import { PaginatedCacheResultOfIndustry_Industry } from "../models/paginated-cache-result-of-industry-_industry";
import { PaginatedCacheResultOfOccupation } from "../models/paginated-cache-result-of-occupation";
import { PaginatedCacheResultOfOccupation_MajorGroup } from "../models/paginated-cache-result-of-occupation-_major-group";
import { PaginatedCacheResultOfOccupation_MinorGroup } from "../models/paginated-cache-result-of-occupation-_minor-group";
import { PaginatedCacheResultOfOccupation_BroadGroup } from "../models/paginated-cache-result-of-occupation-_broad-group";
import { PaginatedCacheResultOfTitle } from "../models/paginated-cache-result-of-title";
import { PaginatedCacheResultOfJobDepartment } from "../models/paginated-cache-result-of-job-department";
import { PaginatedCacheResultOfJobSeniority } from "../models/paginated-cache-result-of-job-seniority";
import { PaginatedCacheResultOfCleanLocation_Country } from "../models/paginated-cache-result-of-clean-location-_country";
import { PaginatedCacheResultOfCleanLocation } from "../models/paginated-cache-result-of-clean-location";
import { PaginatedCacheResultOfAttribute_Type } from "../models/paginated-cache-result-of-attribute-_type";
import { PaginatedCacheResultOfAttribute_SubType } from "../models/paginated-cache-result-of-attribute-_sub-type";
import { PaginatedCacheResultOfAttribute_Category } from "../models/paginated-cache-result-of-attribute-_category";
import { FilterKeys } from "../models/filter-keys";
@Injectable({
  providedIn: "root",
})
class CacheDataService extends __BaseService {
  static readonly cacheDataGetCompaniesPath = "/api/CacheData/GetCompanies";
  static readonly cacheDataSearchCompaniesPath =
    "/api/CacheData/SearchCompanies";
  static readonly cacheDataGetIndustriesPath = "/api/CacheData/GetIndustries";
  static readonly cacheDataSearchIndustriesPath =
    "/api/CacheData/SearchIndustries";
  static readonly cacheDataGetIndustrySectorsPath =
    "/api/CacheData/GetIndustrySectors";
  static readonly cacheDataGetIndustryIndustriesBySectorPath =
    "/api/CacheData/GetIndustryIndustriesBySector";
  static readonly cacheDataGetIndustriesBySectorAndIndustryPath =
    "/api/CacheData/GetIndustriesBySectorAndIndustry";
  static readonly cacheDataGetOccupationsPath = "/api/CacheData/GetOccupations";
  static readonly cacheDataGetOccupationMajorGroupsPath =
    "/api/CacheData/GetOccupationMajorGroups";
  static readonly cacheDataGetOccupationMinorGroupsPath =
    "/api/CacheData/GetOccupationMinorGroups";
  static readonly cacheDataGetOccupationBroadGroupsPath =
    "/api/CacheData/GetOccupationBroadGroups";
  static readonly cacheDataGetOccupationSocCodesPath =
    "/api/CacheData/GetOccupationSocCodes";
  static readonly cacheDataGetOccupationsForMajorAndMinorGroupPath =
    "/api/CacheData/GetOccupationsForMajorAndMinorGroup";
  static readonly cacheDataGetTitlesPath = "/api/CacheData/GetTitles";
  static readonly cacheDataSearchTitlesPath = "/api/CacheData/SearchTitles";
  static readonly cacheDataSearchJobDepartmentsPath =
    "/api/CacheData/SearchJobDepartments";
  static readonly cacheDataSearchJobSenioritiesPath =
    "/api/CacheData/SearchJobSeniorities";
  static readonly cacheDataSearchCleanLocationCountriesPath =
    "/api/CacheData/SearchCleanLocationCountries";
  static readonly cacheDataSearchCleanLocationsPath =
    "/api/CacheData/SearchCleanLocations";
  static readonly cacheDataGetAttributeTypesPath =
    "/api/CacheData/GetAttributeTypes";
  static readonly cacheDataGetAttributeSubTypesByAttributeTypePath =
    "/api/CacheData/GetAttributeSubTypesByAttributeType";
  static readonly cacheDataGetAttributeCategoriesByAttributeTypeAndSubTypePath =
    "/api/CacheData/GetAttributeCategoriesByAttributeTypeAndSubType";
  static readonly cacheDataCacheStatePath = "/api/CacheData/CacheState";
  static readonly cacheDataClearAllCachePath = "/api/CacheData/ClearAllCache";
  static readonly cacheDataCacheKeyExportPath = "/api/CacheData/CacheKeyExport";

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * @param params The `CacheDataService.CacheDataGetCompaniesParams` containing the following parameters:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   */
  cacheDataGetCompaniesResponse(
    params: CacheDataService.CacheDataGetCompaniesParams
  ): __Observable<__StrictHttpResponse<PaginatedCacheResultOfCompany>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.pageSize != null)
      __params = __params.set("pageSize", params.pageSize.toString());
    if (params.pageNumber != null)
      __params = __params.set("pageNumber", params.pageNumber.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/CacheData/GetCompanies`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PaginatedCacheResultOfCompany>;
      })
    );
  }
  /**
   * @param params The `CacheDataService.CacheDataGetCompaniesParams` containing the following parameters:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   */
  cacheDataGetCompanies(
    params: CacheDataService.CacheDataGetCompaniesParams
  ): __Observable<PaginatedCacheResultOfCompany> {
    return this.cacheDataGetCompaniesResponse(params).pipe(
      __map((_r) => _r.body as PaginatedCacheResultOfCompany)
    );
  }

  /**
   * @param params The `CacheDataService.CacheDataSearchCompaniesParams` containing the following parameters:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   *
   * - `names`:
   */
  cacheDataSearchCompaniesResponse(
    params: CacheDataService.CacheDataSearchCompaniesParams
  ): __Observable<__StrictHttpResponse<PaginatedCacheResultOfCompany>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.pageSize != null)
      __params = __params.set("pageSize", params.pageSize.toString());
    if (params.pageNumber != null)
      __params = __params.set("pageNumber", params.pageNumber.toString());
    (params.names || []).forEach((val) => {
      if (val != null) __params = __params.append("names", val.toString());
    });
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/CacheData/SearchCompanies`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PaginatedCacheResultOfCompany>;
      })
    );
  }
  /**
   * @param params The `CacheDataService.CacheDataSearchCompaniesParams` containing the following parameters:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   *
   * - `names`:
   */
  cacheDataSearchCompanies(
    params: CacheDataService.CacheDataSearchCompaniesParams
  ): __Observable<PaginatedCacheResultOfCompany> {
    return this.cacheDataSearchCompaniesResponse(params).pipe(
      __map((_r) => _r.body as PaginatedCacheResultOfCompany)
    );
  }

  /**
   * @param params The `CacheDataService.CacheDataGetIndustriesParams` containing the following parameters:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   */
  cacheDataGetIndustriesResponse(
    params: CacheDataService.CacheDataGetIndustriesParams
  ): __Observable<__StrictHttpResponse<PaginatedCacheResultOfIndustry>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.pageSize != null)
      __params = __params.set("pageSize", params.pageSize.toString());
    if (params.pageNumber != null)
      __params = __params.set("pageNumber", params.pageNumber.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/CacheData/GetIndustries`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PaginatedCacheResultOfIndustry>;
      })
    );
  }
  /**
   * @param params The `CacheDataService.CacheDataGetIndustriesParams` containing the following parameters:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   */
  cacheDataGetIndustries(
    params: CacheDataService.CacheDataGetIndustriesParams
  ): __Observable<PaginatedCacheResultOfIndustry> {
    return this.cacheDataGetIndustriesResponse(params).pipe(
      __map((_r) => _r.body as PaginatedCacheResultOfIndustry)
    );
  }

  /**
   * @param params The `CacheDataService.CacheDataSearchIndustriesParams` containing the following parameters:
   *
   * - `subIndustry`:
   *
   * - `sector`:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   *
   * - `naics`:
   *
   * - `label`:
   *
   * - `industry`:
   */
  cacheDataSearchIndustriesResponse(
    params: CacheDataService.CacheDataSearchIndustriesParams
  ): __Observable<__StrictHttpResponse<PaginatedCacheResultOfCompany>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.subIndustry != null)
      __params = __params.set("subIndustry", params.subIndustry.toString());
    if (params.sector != null)
      __params = __params.set("sector", params.sector.toString());
    if (params.pageSize != null)
      __params = __params.set("pageSize", params.pageSize.toString());
    if (params.pageNumber != null)
      __params = __params.set("pageNumber", params.pageNumber.toString());
    if (params.naics != null)
      __params = __params.set("naics", params.naics.toString());
    if (params.label != null)
      __params = __params.set("label", params.label.toString());
    if (params.industry != null)
      __params = __params.set("industry", params.industry.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/CacheData/SearchIndustries`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PaginatedCacheResultOfCompany>;
      })
    );
  }
  /**
   * @param params The `CacheDataService.CacheDataSearchIndustriesParams` containing the following parameters:
   *
   * - `subIndustry`:
   *
   * - `sector`:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   *
   * - `naics`:
   *
   * - `label`:
   *
   * - `industry`:
   */
  cacheDataSearchIndustries(
    params: CacheDataService.CacheDataSearchIndustriesParams
  ): __Observable<PaginatedCacheResultOfCompany> {
    return this.cacheDataSearchIndustriesResponse(params).pipe(
      __map((_r) => _r.body as PaginatedCacheResultOfCompany)
    );
  }

  /**
   * @param params The `CacheDataService.CacheDataGetIndustrySectorsParams` containing the following parameters:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   */
  cacheDataGetIndustrySectorsResponse(
    params: CacheDataService.CacheDataGetIndustrySectorsParams
  ): __Observable<__StrictHttpResponse<PaginatedCacheResultOfIndustry_Sector>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.pageSize != null)
      __params = __params.set("pageSize", params.pageSize.toString());
    if (params.pageNumber != null)
      __params = __params.set("pageNumber", params.pageNumber.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/CacheData/GetIndustrySectors`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PaginatedCacheResultOfIndustry_Sector>;
      })
    );
  }
  /**
   * @param params The `CacheDataService.CacheDataGetIndustrySectorsParams` containing the following parameters:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   */
  cacheDataGetIndustrySectors(
    params: CacheDataService.CacheDataGetIndustrySectorsParams
  ): __Observable<PaginatedCacheResultOfIndustry_Sector> {
    return this.cacheDataGetIndustrySectorsResponse(params).pipe(
      __map((_r) => _r.body as PaginatedCacheResultOfIndustry_Sector)
    );
  }

  /**
   * @param params The `CacheDataService.CacheDataGetIndustryIndustriesBySectorParams` containing the following parameters:
   *
   * - `sector`:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   */
  cacheDataGetIndustryIndustriesBySectorResponse(
    params: CacheDataService.CacheDataGetIndustryIndustriesBySectorParams
  ): __Observable<
    __StrictHttpResponse<PaginatedCacheResultOfIndustry_Industry>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.sector != null)
      __params = __params.set("sector", params.sector.toString());
    if (params.pageSize != null)
      __params = __params.set("pageSize", params.pageSize.toString());
    if (params.pageNumber != null)
      __params = __params.set("pageNumber", params.pageNumber.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/CacheData/GetIndustryIndustriesBySector`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PaginatedCacheResultOfIndustry_Industry>;
      })
    );
  }
  /**
   * @param params The `CacheDataService.CacheDataGetIndustryIndustriesBySectorParams` containing the following parameters:
   *
   * - `sector`:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   */
  cacheDataGetIndustryIndustriesBySector(
    params: CacheDataService.CacheDataGetIndustryIndustriesBySectorParams
  ): __Observable<PaginatedCacheResultOfIndustry_Industry> {
    return this.cacheDataGetIndustryIndustriesBySectorResponse(params).pipe(
      __map((_r) => _r.body as PaginatedCacheResultOfIndustry_Industry)
    );
  }

  /**
   * @param params The `CacheDataService.CacheDataGetIndustriesBySectorAndIndustryParams` containing the following parameters:
   *
   * - `sector`:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   *
   * - `industry`:
   */
  cacheDataGetIndustriesBySectorAndIndustryResponse(
    params: CacheDataService.CacheDataGetIndustriesBySectorAndIndustryParams
  ): __Observable<__StrictHttpResponse<PaginatedCacheResultOfIndustry>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.sector != null)
      __params = __params.set("sector", params.sector.toString());
    if (params.pageSize != null)
      __params = __params.set("pageSize", params.pageSize.toString());
    if (params.pageNumber != null)
      __params = __params.set("pageNumber", params.pageNumber.toString());
    if (params.industry != null)
      __params = __params.set("industry", params.industry.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/CacheData/GetIndustriesBySectorAndIndustry`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PaginatedCacheResultOfIndustry>;
      })
    );
  }
  /**
   * @param params The `CacheDataService.CacheDataGetIndustriesBySectorAndIndustryParams` containing the following parameters:
   *
   * - `sector`:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   *
   * - `industry`:
   */
  cacheDataGetIndustriesBySectorAndIndustry(
    params: CacheDataService.CacheDataGetIndustriesBySectorAndIndustryParams
  ): __Observable<PaginatedCacheResultOfIndustry> {
    return this.cacheDataGetIndustriesBySectorAndIndustryResponse(params).pipe(
      __map((_r) => _r.body as PaginatedCacheResultOfIndustry)
    );
  }

  /**
   * @param params The `CacheDataService.CacheDataGetOccupationsParams` containing the following parameters:
   *
   * - `socCode`:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   */
  cacheDataGetOccupationsResponse(
    params: CacheDataService.CacheDataGetOccupationsParams
  ): __Observable<__StrictHttpResponse<PaginatedCacheResultOfOccupation>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.socCode != null)
      __params = __params.set("socCode", params.socCode.toString());
    if (params.pageSize != null)
      __params = __params.set("pageSize", params.pageSize.toString());
    if (params.pageNumber != null)
      __params = __params.set("pageNumber", params.pageNumber.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/CacheData/GetOccupations`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PaginatedCacheResultOfOccupation>;
      })
    );
  }
  /**
   * @param params The `CacheDataService.CacheDataGetOccupationsParams` containing the following parameters:
   *
   * - `socCode`:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   */
  cacheDataGetOccupations(
    params: CacheDataService.CacheDataGetOccupationsParams
  ): __Observable<PaginatedCacheResultOfOccupation> {
    return this.cacheDataGetOccupationsResponse(params).pipe(
      __map((_r) => _r.body as PaginatedCacheResultOfOccupation)
    );
  }

  /**
   * @param params The `CacheDataService.CacheDataGetOccupationMajorGroupsParams` containing the following parameters:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   */
  cacheDataGetOccupationMajorGroupsResponse(
    params: CacheDataService.CacheDataGetOccupationMajorGroupsParams
  ): __Observable<
    __StrictHttpResponse<PaginatedCacheResultOfOccupation_MajorGroup>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.pageSize != null)
      __params = __params.set("pageSize", params.pageSize.toString());
    if (params.pageNumber != null)
      __params = __params.set("pageNumber", params.pageNumber.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/CacheData/GetOccupationMajorGroups`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PaginatedCacheResultOfOccupation_MajorGroup>;
      })
    );
  }
  /**
   * @param params The `CacheDataService.CacheDataGetOccupationMajorGroupsParams` containing the following parameters:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   */
  cacheDataGetOccupationMajorGroups(
    params: CacheDataService.CacheDataGetOccupationMajorGroupsParams
  ): __Observable<PaginatedCacheResultOfOccupation_MajorGroup> {
    return this.cacheDataGetOccupationMajorGroupsResponse(params).pipe(
      __map((_r) => _r.body as PaginatedCacheResultOfOccupation_MajorGroup)
    );
  }

  /**
   * @param params The `CacheDataService.CacheDataGetOccupationMinorGroupsParams` containing the following parameters:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   *
   * - `majorGroupId`:
   */
  cacheDataGetOccupationMinorGroupsResponse(
    params: CacheDataService.CacheDataGetOccupationMinorGroupsParams
  ): __Observable<
    __StrictHttpResponse<PaginatedCacheResultOfOccupation_MinorGroup>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.pageSize != null)
      __params = __params.set("pageSize", params.pageSize.toString());
    if (params.pageNumber != null)
      __params = __params.set("pageNumber", params.pageNumber.toString());
    if (params.majorGroupId != null)
      __params = __params.set("majorGroupId", params.majorGroupId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/CacheData/GetOccupationMinorGroups`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PaginatedCacheResultOfOccupation_MinorGroup>;
      })
    );
  }
  /**
   * @param params The `CacheDataService.CacheDataGetOccupationMinorGroupsParams` containing the following parameters:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   *
   * - `majorGroupId`:
   */
  cacheDataGetOccupationMinorGroups(
    params: CacheDataService.CacheDataGetOccupationMinorGroupsParams
  ): __Observable<PaginatedCacheResultOfOccupation_MinorGroup> {
    return this.cacheDataGetOccupationMinorGroupsResponse(params).pipe(
      __map((_r) => _r.body as PaginatedCacheResultOfOccupation_MinorGroup)
    );
  }

  /**
   * @param params The `CacheDataService.CacheDataGetOccupationBroadGroupsParams` containing the following parameters:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   *
   * - `minorGroupId`:
   */
  cacheDataGetOccupationBroadGroupsResponse(
    params: CacheDataService.CacheDataGetOccupationBroadGroupsParams
  ): __Observable<
    __StrictHttpResponse<PaginatedCacheResultOfOccupation_BroadGroup>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.pageSize != null)
      __params = __params.set("pageSize", params.pageSize.toString());
    if (params.pageNumber != null)
      __params = __params.set("pageNumber", params.pageNumber.toString());
    if (params.minorGroupId != null)
      __params = __params.set("minorGroupId", params.minorGroupId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/CacheData/GetOccupationBroadGroups`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PaginatedCacheResultOfOccupation_BroadGroup>;
      })
    );
  }
  /**
   * @param params The `CacheDataService.CacheDataGetOccupationBroadGroupsParams` containing the following parameters:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   *
   * - `minorGroupId`:
   */
  cacheDataGetOccupationBroadGroups(
    params: CacheDataService.CacheDataGetOccupationBroadGroupsParams
  ): __Observable<PaginatedCacheResultOfOccupation_BroadGroup> {
    return this.cacheDataGetOccupationBroadGroupsResponse(params).pipe(
      __map((_r) => _r.body as PaginatedCacheResultOfOccupation_BroadGroup)
    );
  }

  /**
   * @param params The `CacheDataService.CacheDataGetOccupationSocCodesParams` containing the following parameters:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   *
   * - `minorGroupId`:
   *
   * - `majorGroupId`:
   *
   * - `broadGroupId`:
   */
  cacheDataGetOccupationSocCodesResponse(
    params: CacheDataService.CacheDataGetOccupationSocCodesParams
  ): __Observable<__StrictHttpResponse<PaginatedCacheResultOfOccupation>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.pageSize != null)
      __params = __params.set("pageSize", params.pageSize.toString());
    if (params.pageNumber != null)
      __params = __params.set("pageNumber", params.pageNumber.toString());
    if (params.minorGroupId != null)
      __params = __params.set("minorGroupId", params.minorGroupId.toString());
    if (params.majorGroupId != null)
      __params = __params.set("majorGroupId", params.majorGroupId.toString());
    if (params.broadGroupId != null)
      __params = __params.set("broadGroupId", params.broadGroupId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/CacheData/GetOccupationSocCodes`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PaginatedCacheResultOfOccupation>;
      })
    );
  }
  /**
   * @param params The `CacheDataService.CacheDataGetOccupationSocCodesParams` containing the following parameters:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   *
   * - `minorGroupId`:
   *
   * - `majorGroupId`:
   *
   * - `broadGroupId`:
   */
  cacheDataGetOccupationSocCodes(
    params: CacheDataService.CacheDataGetOccupationSocCodesParams
  ): __Observable<PaginatedCacheResultOfOccupation> {
    return this.cacheDataGetOccupationSocCodesResponse(params).pipe(
      __map((_r) => _r.body as PaginatedCacheResultOfOccupation)
    );
  }

  /**
   * @param params The `CacheDataService.CacheDataGetOccupationsForMajorAndMinorGroupParams` containing the following parameters:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   *
   * - `minorGroupId`:
   *
   * - `majorGroupId`:
   */
  cacheDataGetOccupationsForMajorAndMinorGroupResponse(
    params: CacheDataService.CacheDataGetOccupationsForMajorAndMinorGroupParams
  ): __Observable<__StrictHttpResponse<PaginatedCacheResultOfOccupation>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.pageSize != null)
      __params = __params.set("pageSize", params.pageSize.toString());
    if (params.pageNumber != null)
      __params = __params.set("pageNumber", params.pageNumber.toString());
    if (params.minorGroupId != null)
      __params = __params.set("minorGroupId", params.minorGroupId.toString());
    if (params.majorGroupId != null)
      __params = __params.set("majorGroupId", params.majorGroupId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/CacheData/GetOccupationsForMajorAndMinorGroup`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PaginatedCacheResultOfOccupation>;
      })
    );
  }
  /**
   * @param params The `CacheDataService.CacheDataGetOccupationsForMajorAndMinorGroupParams` containing the following parameters:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   *
   * - `minorGroupId`:
   *
   * - `majorGroupId`:
   */
  cacheDataGetOccupationsForMajorAndMinorGroup(
    params: CacheDataService.CacheDataGetOccupationsForMajorAndMinorGroupParams
  ): __Observable<PaginatedCacheResultOfOccupation> {
    return this.cacheDataGetOccupationsForMajorAndMinorGroupResponse(
      params
    ).pipe(__map((_r) => _r.body as PaginatedCacheResultOfOccupation));
  }

  /**
   * @param params The `CacheDataService.CacheDataGetTitlesParams` containing the following parameters:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   */
  cacheDataGetTitlesResponse(
    params: CacheDataService.CacheDataGetTitlesParams
  ): __Observable<__StrictHttpResponse<PaginatedCacheResultOfTitle>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.pageSize != null)
      __params = __params.set("pageSize", params.pageSize.toString());
    if (params.pageNumber != null)
      __params = __params.set("pageNumber", params.pageNumber.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/CacheData/GetTitles`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PaginatedCacheResultOfTitle>;
      })
    );
  }
  /**
   * @param params The `CacheDataService.CacheDataGetTitlesParams` containing the following parameters:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   */
  cacheDataGetTitles(
    params: CacheDataService.CacheDataGetTitlesParams
  ): __Observable<PaginatedCacheResultOfTitle> {
    return this.cacheDataGetTitlesResponse(params).pipe(
      __map((_r) => _r.body as PaginatedCacheResultOfTitle)
    );
  }

  /**
   * @param params The `CacheDataService.CacheDataSearchTitlesParams` containing the following parameters:
   *
   * - `titlesSearch`:
   *
   * - `senioritiesSearch`:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   *
   * - `departmentsSearch`:
   */
  cacheDataSearchTitlesResponse(
    params: CacheDataService.CacheDataSearchTitlesParams
  ): __Observable<__StrictHttpResponse<PaginatedCacheResultOfTitle>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    (params.titlesSearch || []).forEach((val) => {
      if (val != null)
        __params = __params.append("titlesSearch", val.toString());
    });
    (params.senioritiesSearch || []).forEach((val) => {
      if (val != null)
        __params = __params.append("senioritiesSearch", val.toString());
    });
    if (params.pageSize != null)
      __params = __params.set("pageSize", params.pageSize.toString());
    if (params.pageNumber != null)
      __params = __params.set("pageNumber", params.pageNumber.toString());
    (params.departmentsSearch || []).forEach((val) => {
      if (val != null)
        __params = __params.append("departmentsSearch", val.toString());
    });
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/CacheData/SearchTitles`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PaginatedCacheResultOfTitle>;
      })
    );
  }
  /**
   * @param params The `CacheDataService.CacheDataSearchTitlesParams` containing the following parameters:
   *
   * - `titlesSearch`:
   *
   * - `senioritiesSearch`:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   *
   * - `departmentsSearch`:
   */
  cacheDataSearchTitles(
    params: CacheDataService.CacheDataSearchTitlesParams
  ): __Observable<PaginatedCacheResultOfTitle> {
    return this.cacheDataSearchTitlesResponse(params).pipe(
      __map((_r) => _r.body as PaginatedCacheResultOfTitle)
    );
  }

  /**
   * @param params The `CacheDataService.CacheDataSearchJobDepartmentsParams` containing the following parameters:
   *
   * - `search`:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   */
  cacheDataSearchJobDepartmentsResponse(
    params: CacheDataService.CacheDataSearchJobDepartmentsParams
  ): __Observable<__StrictHttpResponse<PaginatedCacheResultOfJobDepartment>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    (params.search || []).forEach((val) => {
      if (val != null) __params = __params.append("search", val.toString());
    });
    if (params.pageSize != null)
      __params = __params.set("pageSize", params.pageSize.toString());
    if (params.pageNumber != null)
      __params = __params.set("pageNumber", params.pageNumber.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/CacheData/SearchJobDepartments`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PaginatedCacheResultOfJobDepartment>;
      })
    );
  }
  /**
   * @param params The `CacheDataService.CacheDataSearchJobDepartmentsParams` containing the following parameters:
   *
   * - `search`:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   */
  cacheDataSearchJobDepartments(
    params: CacheDataService.CacheDataSearchJobDepartmentsParams
  ): __Observable<PaginatedCacheResultOfJobDepartment> {
    return this.cacheDataSearchJobDepartmentsResponse(params).pipe(
      __map((_r) => _r.body as PaginatedCacheResultOfJobDepartment)
    );
  }

  /**
   * @param params The `CacheDataService.CacheDataSearchJobSenioritiesParams` containing the following parameters:
   *
   * - `search`:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   */
  cacheDataSearchJobSenioritiesResponse(
    params: CacheDataService.CacheDataSearchJobSenioritiesParams
  ): __Observable<__StrictHttpResponse<PaginatedCacheResultOfJobSeniority>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    (params.search || []).forEach((val) => {
      if (val != null) __params = __params.append("search", val.toString());
    });
    if (params.pageSize != null)
      __params = __params.set("pageSize", params.pageSize.toString());
    if (params.pageNumber != null)
      __params = __params.set("pageNumber", params.pageNumber.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/CacheData/SearchJobSeniorities`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PaginatedCacheResultOfJobSeniority>;
      })
    );
  }
  /**
   * @param params The `CacheDataService.CacheDataSearchJobSenioritiesParams` containing the following parameters:
   *
   * - `search`:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   */
  cacheDataSearchJobSeniorities(
    params: CacheDataService.CacheDataSearchJobSenioritiesParams
  ): __Observable<PaginatedCacheResultOfJobSeniority> {
    return this.cacheDataSearchJobSenioritiesResponse(params).pipe(
      __map((_r) => _r.body as PaginatedCacheResultOfJobSeniority)
    );
  }

  /**
   * @param params The `CacheDataService.CacheDataSearchCleanLocationCountriesParams` containing the following parameters:
   *
   * - `search`:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   */
  cacheDataSearchCleanLocationCountriesResponse(
    params: CacheDataService.CacheDataSearchCleanLocationCountriesParams
  ): __Observable<
    __StrictHttpResponse<PaginatedCacheResultOfCleanLocation_Country>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.search != null)
      __params = __params.set("search", params.search.toString());
    if (params.pageSize != null)
      __params = __params.set("pageSize", params.pageSize.toString());
    if (params.pageNumber != null)
      __params = __params.set("pageNumber", params.pageNumber.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/CacheData/SearchCleanLocationCountries`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PaginatedCacheResultOfCleanLocation_Country>;
      })
    );
  }
  /**
   * @param params The `CacheDataService.CacheDataSearchCleanLocationCountriesParams` containing the following parameters:
   *
   * - `search`:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   */
  cacheDataSearchCleanLocationCountries(
    params: CacheDataService.CacheDataSearchCleanLocationCountriesParams
  ): __Observable<PaginatedCacheResultOfCleanLocation_Country> {
    return this.cacheDataSearchCleanLocationCountriesResponse(params).pipe(
      __map((_r) => _r.body as PaginatedCacheResultOfCleanLocation_Country)
    );
  }

  /**
   * @param params The `CacheDataService.CacheDataSearchCleanLocationsParams` containing the following parameters:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   *
   * - `locationSearch`:
   *
   * - `countrySearch`:
   */
  cacheDataSearchCleanLocationsResponse(
    params: CacheDataService.CacheDataSearchCleanLocationsParams
  ): __Observable<__StrictHttpResponse<PaginatedCacheResultOfCleanLocation>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.pageSize != null)
      __params = __params.set("pageSize", params.pageSize.toString());
    if (params.pageNumber != null)
      __params = __params.set("pageNumber", params.pageNumber.toString());
    (params.locationSearch || []).forEach((val) => {
      if (val != null)
        __params = __params.append("locationSearch", val.toString());
    });
    if (params.countrySearch != null)
      __params = __params.set("countrySearch", params.countrySearch.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/CacheData/SearchCleanLocations`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PaginatedCacheResultOfCleanLocation>;
      })
    );
  }
  /**
   * @param params The `CacheDataService.CacheDataSearchCleanLocationsParams` containing the following parameters:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   *
   * - `locationSearch`:
   *
   * - `countrySearch`:
   */
  cacheDataSearchCleanLocations(
    params: CacheDataService.CacheDataSearchCleanLocationsParams
  ): __Observable<PaginatedCacheResultOfCleanLocation> {
    return this.cacheDataSearchCleanLocationsResponse(params).pipe(
      __map((_r) => _r.body as PaginatedCacheResultOfCleanLocation)
    );
  }

  /**
   * @param params The `CacheDataService.CacheDataGetAttributeTypesParams` containing the following parameters:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   */
  cacheDataGetAttributeTypesResponse(
    params: CacheDataService.CacheDataGetAttributeTypesParams
  ): __Observable<__StrictHttpResponse<PaginatedCacheResultOfAttribute_Type>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.pageSize != null)
      __params = __params.set("pageSize", params.pageSize.toString());
    if (params.pageNumber != null)
      __params = __params.set("pageNumber", params.pageNumber.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/CacheData/GetAttributeTypes`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PaginatedCacheResultOfAttribute_Type>;
      })
    );
  }
  /**
   * @param params The `CacheDataService.CacheDataGetAttributeTypesParams` containing the following parameters:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   */
  cacheDataGetAttributeTypes(
    params: CacheDataService.CacheDataGetAttributeTypesParams
  ): __Observable<PaginatedCacheResultOfAttribute_Type> {
    return this.cacheDataGetAttributeTypesResponse(params).pipe(
      __map((_r) => _r.body as PaginatedCacheResultOfAttribute_Type)
    );
  }

  /**
   * @param params The `CacheDataService.CacheDataGetAttributeSubTypesByAttributeTypeParams` containing the following parameters:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   *
   * - `attributeType`:
   */
  cacheDataGetAttributeSubTypesByAttributeTypeResponse(
    params: CacheDataService.CacheDataGetAttributeSubTypesByAttributeTypeParams
  ): __Observable<
    __StrictHttpResponse<PaginatedCacheResultOfAttribute_SubType>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.pageSize != null)
      __params = __params.set("pageSize", params.pageSize.toString());
    if (params.pageNumber != null)
      __params = __params.set("pageNumber", params.pageNumber.toString());
    if (params.attributeType != null)
      __params = __params.set("attributeType", params.attributeType.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/CacheData/GetAttributeSubTypesByAttributeType`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PaginatedCacheResultOfAttribute_SubType>;
      })
    );
  }
  /**
   * @param params The `CacheDataService.CacheDataGetAttributeSubTypesByAttributeTypeParams` containing the following parameters:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   *
   * - `attributeType`:
   */
  cacheDataGetAttributeSubTypesByAttributeType(
    params: CacheDataService.CacheDataGetAttributeSubTypesByAttributeTypeParams
  ): __Observable<PaginatedCacheResultOfAttribute_SubType> {
    return this.cacheDataGetAttributeSubTypesByAttributeTypeResponse(
      params
    ).pipe(__map((_r) => _r.body as PaginatedCacheResultOfAttribute_SubType));
  }

  /**
   * @param params The `CacheDataService.CacheDataGetAttributeCategoriesByAttributeTypeAndSubTypeParams` containing the following parameters:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   *
   * - `attributeType`:
   *
   * - `attributeSubType`:
   */
  cacheDataGetAttributeCategoriesByAttributeTypeAndSubTypeResponse(
    params: CacheDataService.CacheDataGetAttributeCategoriesByAttributeTypeAndSubTypeParams
  ): __Observable<
    __StrictHttpResponse<PaginatedCacheResultOfAttribute_Category>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.pageSize != null)
      __params = __params.set("pageSize", params.pageSize.toString());
    if (params.pageNumber != null)
      __params = __params.set("pageNumber", params.pageNumber.toString());
    if (params.attributeType != null)
      __params = __params.set("attributeType", params.attributeType.toString());
    if (params.attributeSubType != null)
      __params = __params.set(
        "attributeSubType",
        params.attributeSubType.toString()
      );
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl +
        `/api/CacheData/GetAttributeCategoriesByAttributeTypeAndSubType`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PaginatedCacheResultOfAttribute_Category>;
      })
    );
  }
  /**
   * @param params The `CacheDataService.CacheDataGetAttributeCategoriesByAttributeTypeAndSubTypeParams` containing the following parameters:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   *
   * - `attributeType`:
   *
   * - `attributeSubType`:
   */
  cacheDataGetAttributeCategoriesByAttributeTypeAndSubType(
    params: CacheDataService.CacheDataGetAttributeCategoriesByAttributeTypeAndSubTypeParams
  ): __Observable<PaginatedCacheResultOfAttribute_Category> {
    return this.cacheDataGetAttributeCategoriesByAttributeTypeAndSubTypeResponse(
      params
    ).pipe(__map((_r) => _r.body as PaginatedCacheResultOfAttribute_Category));
  }

  /**
   * @param token undefined
   */
  cacheDataCacheStateResponse(
    token?: null | string
  ): __Observable<__StrictHttpResponse<{ [key: string]: string }>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (token != null) __params = __params.set("token", token.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/CacheData/CacheState`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{ [key: string]: string }>;
      })
    );
  }
  /**
   * @param token undefined
   */
  cacheDataCacheState(
    token?: null | string
  ): __Observable<{ [key: string]: string }> {
    return this.cacheDataCacheStateResponse(token).pipe(
      __map((_r) => _r.body as { [key: string]: string })
    );
  }

  /**
   * @param token undefined
   */
  cacheDataClearAllCacheResponse(
    token?: null | string
  ): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (token != null) __params = __params.set("token", token.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/CacheData/ClearAllCache`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === "true",
        }) as __StrictHttpResponse<boolean>;
      })
    );
  }
  /**
   * @param token undefined
   */
  cacheDataClearAllCache(token?: null | string): __Observable<boolean> {
    return this.cacheDataClearAllCacheResponse(token).pipe(
      __map((_r) => _r.body as boolean)
    );
  }
  cacheDataCacheKeyExportResponse(): __Observable<
    __StrictHttpResponse<FilterKeys>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/CacheData/CacheKeyExport`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<FilterKeys>;
      })
    );
  }
  cacheDataCacheKeyExport(): __Observable<FilterKeys> {
    return this.cacheDataCacheKeyExportResponse().pipe(
      __map((_r) => _r.body as FilterKeys)
    );
  }
}

module CacheDataService {
  /**
   * Parameters for CacheDataGetCompanies
   */
  export interface CacheDataGetCompaniesParams {
    pageSize?: number;
    pageNumber?: number;
  }

  /**
   * Parameters for CacheDataSearchCompanies
   */
  export interface CacheDataSearchCompaniesParams {
    pageSize?: number;
    pageNumber?: number;
    names?: null | Array<string>;
  }

  /**
   * Parameters for CacheDataGetIndustries
   */
  export interface CacheDataGetIndustriesParams {
    pageSize?: number;
    pageNumber?: number;
  }

  /**
   * Parameters for CacheDataSearchIndustries
   */
  export interface CacheDataSearchIndustriesParams {
    subIndustry?: null | string;
    sector?: null | string;
    pageSize?: number;
    pageNumber?: number;
    naics?: null | number;
    label?: null | string;
    industry?: null | string;
  }

  /**
   * Parameters for CacheDataGetIndustrySectors
   */
  export interface CacheDataGetIndustrySectorsParams {
    pageSize?: number;
    pageNumber?: number;
  }

  /**
   * Parameters for CacheDataGetIndustryIndustriesBySector
   */
  export interface CacheDataGetIndustryIndustriesBySectorParams {
    sector?: null | string;
    pageSize?: number;
    pageNumber?: number;
  }

  /**
   * Parameters for CacheDataGetIndustriesBySectorAndIndustry
   */
  export interface CacheDataGetIndustriesBySectorAndIndustryParams {
    sector?: null | string;
    pageSize?: number;
    pageNumber?: number;
    industry?: null | string;
  }

  /**
   * Parameters for CacheDataGetOccupations
   */
  export interface CacheDataGetOccupationsParams {
    socCode?: null | string;
    pageSize?: number;
    pageNumber?: number;
  }

  /**
   * Parameters for CacheDataGetOccupationMajorGroups
   */
  export interface CacheDataGetOccupationMajorGroupsParams {
    pageSize?: number;
    pageNumber?: number;
  }

  /**
   * Parameters for CacheDataGetOccupationMinorGroups
   */
  export interface CacheDataGetOccupationMinorGroupsParams {
    pageSize?: number;
    pageNumber?: number;
    majorGroupId?: null | string;
  }

  /**
   * Parameters for CacheDataGetOccupationBroadGroups
   */
  export interface CacheDataGetOccupationBroadGroupsParams {
    pageSize?: number;
    pageNumber?: number;
    minorGroupId?: null | string;
  }

  /**
   * Parameters for CacheDataGetOccupationSocCodes
   */
  export interface CacheDataGetOccupationSocCodesParams {
    pageSize?: number;
    pageNumber?: number;
    minorGroupId?: null | string;
    majorGroupId?: null | string;
    broadGroupId?: null | string;
  }

  /**
   * Parameters for CacheDataGetOccupationsForMajorAndMinorGroup
   */
  export interface CacheDataGetOccupationsForMajorAndMinorGroupParams {
    pageSize?: number;
    pageNumber?: number;
    minorGroupId?: null | string;
    majorGroupId?: null | string;
  }

  /**
   * Parameters for CacheDataGetTitles
   */
  export interface CacheDataGetTitlesParams {
    pageSize?: number;
    pageNumber?: number;
  }

  /**
   * Parameters for CacheDataSearchTitles
   */
  export interface CacheDataSearchTitlesParams {
    titlesSearch?: null | Array<string>;
    senioritiesSearch?: null | Array<string>;
    pageSize?: number;
    pageNumber?: number;
    departmentsSearch?: null | Array<string>;
  }

  /**
   * Parameters for CacheDataSearchJobDepartments
   */
  export interface CacheDataSearchJobDepartmentsParams {
    search?: null | Array<string>;
    pageSize?: number;
    pageNumber?: number;
  }

  /**
   * Parameters for CacheDataSearchJobSeniorities
   */
  export interface CacheDataSearchJobSenioritiesParams {
    search?: null | Array<string>;
    pageSize?: number;
    pageNumber?: number;
  }

  /**
   * Parameters for CacheDataSearchCleanLocationCountries
   */
  export interface CacheDataSearchCleanLocationCountriesParams {
    search?: null | string;
    pageSize?: number;
    pageNumber?: number;
  }

  /**
   * Parameters for CacheDataSearchCleanLocations
   */
  export interface CacheDataSearchCleanLocationsParams {
    pageSize?: number;
    pageNumber?: number;
    locationSearch?: null | Array<string>;
    countrySearch?: null | string;
  }

  /**
   * Parameters for CacheDataGetAttributeTypes
   */
  export interface CacheDataGetAttributeTypesParams {
    pageSize?: number;
    pageNumber?: number;
  }

  /**
   * Parameters for CacheDataGetAttributeSubTypesByAttributeType
   */
  export interface CacheDataGetAttributeSubTypesByAttributeTypeParams {
    pageSize?: number;
    pageNumber?: number;
    attributeType?: null | string;
  }

  /**
   * Parameters for CacheDataGetAttributeCategoriesByAttributeTypeAndSubType
   */
  export interface CacheDataGetAttributeCategoriesByAttributeTypeAndSubTypeParams {
    pageSize?: number;
    pageNumber?: number;
    attributeType?: null | string;
    attributeSubType?: null | string;
  }
}

export { CacheDataService };
